
import { useUserStore } from '@/store/User';
import router from '@/router/Index';
import { Is_Login } from '@/api/PcModule/home';
var noLogin = false
const isLoginAction = async () => {
  const store = useUserStore()
  let userInfo = store.userInfo || {}
  if (userInfo.access_token) {
    let data = await Is_Login({
      token: userInfo.access_token,
    });
    if (data.error) {
      localStorage.removeItem('user')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('shop');
      localStorage.removeItem('main')
      noLogin = true
      setTimeout(() => {
        router.push({
          name: 'login',
        });
      }, 200);
    }
  } else {
    noLogin = true
    setTimeout(() => {
      router.push({
        name: 'login',
        query: { callback: location.protocol + '//' + location.host +  location.pathname + (location.search !== ''  ? '?' + encodeURI(location.search.substring(1)) : '') }
      });
    }, 200);
  }
}
// 全局指令 判断是否登陆
export default (app: any) => {
  app.directive('isLoginClickCheck', {
    mounted(el: any, binding: any) {
      el.addEventListener('mouseup', () => {
        isLoginAction()
      });
      el.addEventListener('click' , () =>{
        if(noLogin){
          el.disabled = true;
        }
      })
    }
  })
}
